module.exports = __webpack_public_path__ + "static/media/live_help.cde8ff59.svg";